import React from "react";
import { Button, Card } from "react-bootstrap";
import { IconSettings2 } from "@tabler/icons-react";
import LayoutDashboard from "layouts/layout-dashboard-collapse";

const PengaturanAplikasi = () => {
  // Handler untuk membuka pengaturan aplikasi Android (jika tersedia)
  const handleOpenAppSettings = () => {
    // Debug info
    if (!window.AndroidPrintHandler) {
      alert(
        "AndroidPrintHandler tidak ditemukan. Fitur hanya tersedia di perangkat Android dengan integrasi khusus."
      );
      return;
    }
    if (typeof window.AndroidPrintHandler.openSettings !== "function") {
      alert(
        "Fungsi openSettings tidak tersedia pada AndroidPrintHandler. Pastikan aplikasi Android sudah update."
      );
      return;
    }
    // Jika sudah benar, panggil
    try {
      window.AndroidPrintHandler.openSettings();
    } catch (e) {
      alert("Gagal membuka pengaturan aplikasi: " + e.message);
    }
  };

  return (
    <LayoutDashboard>
      <div className="container py-4">
        <Card className="mx-auto" style={{ maxWidth: 480 }}>
          <Card.Body>
            <div className="d-flex align-items-center mb-3">
              <IconSettings2 size={32} className="me-2 text-primary" />
              <h3 className="mb-0">Pengaturan Aplikasi</h3>
            </div>
            <p className="text-muted">
              Buka pengaturan aplikasi Android untuk mengelola izin, cache, dan
              lainnya. Fitur ini hanya aktif di perangkat Android dengan
              integrasi khusus.
            </p>
            <Button variant="primary" onClick={handleOpenAppSettings}>
              Buka Pengaturan Aplikasi
            </Button>
          </Card.Body>
        </Card>
      </div>
    </LayoutDashboard>
  );
};

export default PengaturanAplikasi;
